<template>
  <v-dialog
    :value="value"
    width="500"
    @input="handleInput"
  >
    <v-form @submit.prevent.stop="submit">
      <v-card>
        <v-toolbar
          flat
          dark
          color="primary"
        >
          {{ title }}
          <span
            v-if="mode === 'edit'"
            class="ml-1"
          >(input-{{ fieldId }})</span>
          <v-spacer />
          <v-btn
            icon
            dark
            @click="$emit('input', false)"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-select
            ref="typeInput"
            v-model="form.type"
            :label="$t('Select field type')"
            :items="availableFieldTypes"
            :error-messages="form.errors.type"
            hide-details="auto"
            :class="{'mb-7': !form.errors.type}"
            outlined
            @change="focusLabelInput"
          />

          <v-text-field
            ref="labelInput"
            v-model="form.label"
            :label="$t('Enter field label') + ' *'"
            :error-messages="form.errors.label"
            hide-details="auto"
            :class="{'mb-7': !form.errors.label}"
            outlined
            autofocus
          />

          <v-text-field
            v-if="form.type !== 'checkbox'"
            v-model="form.placeholder"
            :label="$t('Enter field placeholder')"
            :error-messages="form.errors.placeholder"
            hide-details="auto"
            :class="{'mb-7': !form.errors.placeholder}"
            outlined
          />

          <v-switch
            v-model="form.required"
            :label="$t('Field required')"
            :error-messages="form.errors.required"
            hide-details="auto"
            :class="{'mb-7': !form.errors.required}"
          />

          <div
            v-if="form.type === 'select'"
            class="mt-7"
          >
            <contact-form-field-option-form
              v-model="form.options"
              :mode="mode"
              :field="field"
              :faq-id="faqId"
              @refresh-preview="$emit('refresh-preview')"
            />
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey"
            text
            @click="$emit('input', false)"
          >
            {{ $t('Cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            text
            type="submit"
            :loading="form.processing"
            :disabled="form.processing"
          >
            {{ $t('Save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import ContactFormFieldOptionForm from '@/components/faq/ContactFormFieldOptionForm';

export default {
  components: {
    ContactFormFieldOptionForm
  },

  props: {
    value: {
      type: Boolean
    },
    faqId: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: null
    },
    mode: {
      type: String,
      required: false,
      default: 'create'
    },
    preserveState: {
      type: Boolean,
      default: false
    },
    fieldId: {
      type: Number,
      required: false,
      default: null
    },
    fields: {
      type: Array,
      required: true
    },
    fieldTypes: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      form: this.$inertia.form({
        label: '',
        placeholder: '',
        type: 'text',
        required: false,
        options: []
      }),
    }
  },

  computed: {
    field() {
      if (! this.fieldId) {
        return;
      }

      return this.fields.find(field => field.id === this.fieldId);
    },

    availableFieldTypes() {
      return this.fieldTypes.map(type => ({
        value: type,
        text: type
      }));
    }
  },

  watch: {
    fieldId: function (fieldId) {
      if (fieldId && this.mode === 'edit') {
        this.form.label = this.field.default_translation.label;
        this.form.placeholder = this.field.default_translation.placeholder;
        this.form.type = this.field.type;
        this.form.required = this.field.required;
        this.form.options = null;
      } else {
        this.form.reset();
      }
    }
  },

  methods: {
    submit() {
      switch (this.mode) {
        case 'create':
          this.handleCreate();
          break;

        case 'edit':
          this.handleUpdate();
          break;
      }
    },

    focusLabelInput() {
      this.$nextTick(() => {
        this.$refs.typeInput.blur();
        this.$refs.labelInput.focus();
      });
    },

    handleCreate() {
      const url = this.route('faq.contact-field.store', [this.faqId]);

      this.form.post(url, {
        preserveScroll: true,
        onSuccess: () => {
          this.handleInput(false);
          this.$emit('refresh-preview');
        }
      });
    },

    handleUpdate() {
      const url = this.route('faq.contact-field.update', [this.faqId, this.field.id]);

      this.form.patch(url, {
        preserveScroll: true,
        onSuccess: () => {
          this.handleInput(false);
          this.$emit('refresh-preview');
        }
      });
    },

    handleInput(value) {
      this.$emit('input', value);

      if (value === false) {
        this.$nextTick(() => {
          this.form.reset();
          this.form.clearErrors();
        });
      }
    }
  }
}
</script>